import { createFileRoute } from '@tanstack/react-router'
import { ChannelConnection } from '../../../../components/ChannelConnection'

export const Route = createFileRoute('/desa/$slug/dashboard/channel')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    const { slug } = Route.useParams()
    if (!desaId) return null
    return <ChannelConnection desaId={desaId} isDemo={slug === 'demo'} />
  },
})
